<template>
  <AvatarGroup :class="className" :style="style">
    <slot></slot>
  </AvatarGroup>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AvatarGroup from 'primevue/avatargroup'
import type { ONEAvatarGroupProps } from './types'

export default defineComponent({
  name: 'ONEAvatarGroup',
  components: {
    AvatarGroup
  },
  inheritAttrs: false
})
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<ONEAvatarGroupProps>(), {
  className: undefined,
  style: undefined
})
</script>
